import { render, staticRenderFns } from "./OcupacionArea.vue?vue&type=template&id=2100a7c9&"
import script from "./OcupacionArea.vue?vue&type=script&lang=js&"
export * from "./OcupacionArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports